/**
 * Industry gallery quotes slider
 */
import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';

(function() {
    const sections = document.querySelectorAll('[data-js-industry-gallery-quotes]');
    if (!sections.length) return;

    sections.forEach((section) => {
        const swiperEl = section.querySelector('.industry-gallery-swiper');
        const arrows = section.querySelector('.industry-gallery-arrows');
        const prevBtn = section.querySelector('.industry-gallery-prev');
        const nextBtn = section.querySelector('.industry-gallery-next');
        const textBlocks = section.querySelectorAll('.industry-gallery__slide-text');
        const slides = swiperEl ? swiperEl.querySelectorAll('.swiper-slide') : [];

        if (!swiperEl || !prevBtn || !nextBtn) return;

        // hide arrows and skip Swiper setup if just 1 slide
        if (slides.length <= 1) {
            if (arrows) {
                arrows.style.display = 'none';
            }
            return;
        }

        function positionArrows() {
            const firstSlide = swiperEl.querySelector('.swiper-slide');
            const imageWrap = firstSlide && firstSlide.querySelector('.industry-gallery__slide-image-wrap');
            if (imageWrap && arrows) {
                arrows.style.top = imageWrap.getBoundingClientRect().height + 'px';
            }
        }

        const total = textBlocks.length;

        function setActiveText(swiperInstance) {
            const realIndex = swiperInstance.realIndex;
            textBlocks.forEach(function(el, i) {
                el.style.opacity = i === realIndex ? '1' : '0';
            });
        }

        const _swiper = new Swiper(swiperEl, {
            modules: [Navigation, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            observer: true,
            observeParents: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            on: {
                init: function() {
                    if (total > 0) {
                        setActiveText(this);
                    }
                },
                slideChangeTransitionEnd: function() {
                    setActiveText(this);
                },
            },
        });

        positionArrows();
        window.addEventListener('resize', positionArrows);
    });
})();

